export const equipmentFormConfig = ({
	equipmentOptions = [],
	selectedEquipment = ""
} = {}) => [
	{
		fields: [
			{
				name: "equipment",
				label: "Equipamento:",
				type: "select",
				defaultValue: selectedEquipment,
				placeholder: "Selecione",
				options: equipmentOptions,
				disabled: equipmentOptions.length === 0,
				columns: 12
			}
		]
	}
];